import { Image } from '@/atoms/Image'
import { HeadingXS, ParagraphMD, Text } from '@/atoms/Text'
import { Translate, useTranslate } from '@/utils/translate/translate-client'

export function YoungWashingtonNameInCredits() {
  const { t } = useTranslate('pif')

  return (
    <div className="mb-[3.5rem] flex w-full flex-col gap-6 px-4 @container md:mb-16 md:grid md:grid-cols-2 md:gap-9 md:pt-10 lg:pt-0">
      <div style={{ aspectRatio: 1 }} className="relative w-full overflow-hidden rounded-xl lg:max-w-[25.75rem]">
        <Image
          src="https://images.angelstudios.com/image/upload/v1768008817/theatrical/young%20washington/yw-name-in-credits-light.webp"
          alt="Young Washington Name in Credits"
          fill
          sizes="(max-width: 25.75rem) 100vw, 25.75rem"
          className="object-cover"
        />
      </div>

      <div className="my-auto flex flex-col">
        <div className="flex w-fit items-center justify-center bg-[#DA2031] px-3 py-[8px]">
          <Text weight="bold" className="text-base uppercase leading-[100%] text-white md:text-lg">
            {t('limitedTimeOffer', 'Limited Time Offer')}
          </Text>
        </div>

        <HeadingXS className="mt-3" weight="bold">
          {t(
            'etchYourNameInTheMovieCreditsOfYoungWashington',
            'Etch Your Name in the Movie Credits of Young Washington',
          )}
        </HeadingXS>

        <Text className="photon-paragraph-sm md:photon-paragraph-md mt-3">
          {t(
            'youngWashingtonNameInCreditsDescription',
            "Pay it Forward for at least 35 students ($500) to see Young Washington and we'll thank you by including your name in the movie credits—across the theatrical, streaming, and DVD releases.",
          )}
        </Text>

        <ParagraphMD className="mt-6 flex flex-wrap gap-1 leading-tight">
          <Translate t={t} i18nKey="youngWashingtonTheatricalCutoffV5">
            <span className="font-bold">Theatrical Cutoff Date:</span> <span>May 19, 2026</span>
          </Translate>
        </ParagraphMD>
      </div>
    </div>
  )
}
